'use client'

import { Box, Typography } from '@mui/material'
import { useEffect, useState } from 'react'

export default function DAMP_VIS_BAR({ exercise, isRunning, velocity }) {
  const [count, setCount] = useState(1)
  const [maxIterations, setMaxIterations] = useState(exercise.lineas)
  // Estilo para el contenedor padre
  const parentStyle = {
    position: 'relative',
    width: '100%',
    height: '60vh',
  };

  // Función para calcular el espacio entre barras y el ancho de las barras
  const getBarStyles = () => {
    const maxWidth = 16; // Ancho máximo de la barra en píxeles
    const minWidth = 6; // Ancho mínimo de la barra en píxeles
    const maxGap = 250; // Espacio máximo entre barras en píxeles
    const minGap = 10; // Espacio mínimo entre barras en píxeles

    const barWidth = Math.max(minWidth, Math.min(maxWidth, 60 / maxIterations));

    // Cálculo de gapSize con crecimiento exponencial
    const gapSize = Math.max(minGap, Math.min(maxGap, minGap + (maxGap - minGap) * Math.pow(count / maxIterations, 2)));

    return {
      barWidth: {
        xs: `${barWidth * 0.7}px`,
        sm: `${barWidth * 0.7}px`,
        md: `${barWidth}px`,
        lg: `${barWidth * 1.25}px`
      },
      gapSize: `${gapSize}px`
    };
  }

  // Función para calcular la altura de las barras
  const getBarHeight = () => {
    const maxHeight = 60; // Altura máxima en porcentaje
    const minHeight = 10; // Altura mínima en porcentaje (reducida de 20 a 10)
    const height = minHeight + ((maxHeight - minHeight) * (count - 1)) / (maxIterations - 1);
    return `${Math.max(minHeight, height)}%`;
  };

  useEffect(() => {
    let timer = null
    if (isRunning) {
      timer = setInterval(() => {
        setCount((prev) => (prev >= maxIterations ? 1 : prev + 1))
      }, 1000)
    }
    return () => { if (timer) clearInterval(timer)}
  }, [maxIterations, isRunning])

  const { barWidth, gapSize } = getBarStyles();

  return (
    <Box sx={parentStyle}>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          background: "#ffffff",
          padding: '24px 12px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: gapSize,
            height: '100%',
            //transition: 'gap 0.6s ease-in-out',
          }}
        >
          {[0, 1].map((index) => (
            <Box
              key={index}
              sx={{
                position: 'relative',
                width: barWidth,
                height: getBarHeight(),
                bgcolor: 'red',
                //transition: 'height 0.6s ease-in-out',
              }}
            >
              <Typography
                sx={{
                  position: 'absolute',
                  top: '-24px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  fontSize: {
                    xs: '12px',
                    sm: '14px',
                    md: '16px',
                    lg: '18px'
                  },
                  whiteSpace: 'nowrap',
                }}
              >
                {count}
              </Typography>
              <Typography
                sx={{
                  position: 'absolute',
                  bottom: '-24px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  fontSize: {
                    xs: '12px',
                    sm: '14px',
                    md: '16px',
                    lg: '18px'
                  },
                  whiteSpace: 'nowrap',
                }}
              >
                {count}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

